import { atomWithStorage } from 'jotai/utils';

import { Warehouse } from '../api-types/director';

type SelectedWarehouse = {
  id: Warehouse['id'];
};

const WAREHOUSE_LOCAL_STORAGE_KEY = 'selectedWarehouse';

export function invalidateCachedWarehouse() {
  localStorage.removeItem(WAREHOUSE_LOCAL_STORAGE_KEY);
}

export const selectedWarehouseAtom = atomWithStorage<SelectedWarehouse | undefined>(
  WAREHOUSE_LOCAL_STORAGE_KEY,
  undefined,
  undefined,
  {
    getOnInit: true,
  },
);
